import { useState, useEffect, useCallback } from 'react';
import {
  getPlannedExpenses,
  getPlannedForMonth,
  addPlannedExpense as _add,
  updatePlannedExpense as _update,
  deletePlannedExpense as _delete,
  getPlannedYearTotal,
} from '@/services/plannedExpenseService';
import { useAppContext } from '@/context/AppContext';

export function usePlannedExpenses(filters = {}) {
  const [planned, setPlanned] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showToast }         = useAppContext();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getPlannedExpenses(filters);
      setPlanned(data);
    } catch (err) {
      console.error('usePlannedExpenses error:', err);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filters)]);

  useEffect(() => { load(); }, [load]);

  const addPlanned = useCallback(async (expense) => {
    await _add(expense);
    await load();
    showToast('Planned expense added ✓', 'success');
  }, [load, showToast]);

  const updatePlanned = useCallback(async (id, expense) => {
    await _update(id, expense);
    await load();
    showToast('Planned expense updated ✓', 'success');
  }, [load, showToast]);

  const deletePlanned = useCallback(async (id) => {
    await _delete(id);
    setPlanned(prev => prev.filter(p => p.id !== id));
    showToast('Planned expense deleted', 'info');
  }, [showToast]);

  const yearTotal = planned.reduce((s, p) => s + p.amount, 0);

  return { planned, loading, yearTotal, addPlanned, updatePlanned, deletePlanned, refetch: load };
}

export function usePlannedForMonth(month) {
  const [planned, setPlanned] = useState([]);
  const [monthTotal, setMonthTotal] = useState(0);

  useEffect(() => {
    if (!month) return;
    getPlannedForMonth(month).then(data => {
      setPlanned(data);
      setMonthTotal(data.reduce((s, p) => s + p.amount, 0));
    }).catch(() => {});
  }, [month]);

  return { planned, monthTotal };
}
